import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetAnalysisSegment state domain
 */

const selectWidgetAnalysisSegmentDomain = (state) =>
  state.get("widgetAnalysisSegment", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingRanks = () =>
  createSelector(selectWidgetAnalysisSegmentDomain, (state) =>
    state.get("isLoadingRanks")
  )

export const makeSelectRanks = () =>
  createSelector(selectWidgetAnalysisSegmentDomain, (state) =>
    state.get("ranks")
  )

/**
 * Default selector used by WidgetAnalysisSegment
 */

const makeSelectWidgetAnalysisSegment = () =>
  createSelector(selectWidgetAnalysisSegmentDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetAnalysisSegment
export { selectWidgetAnalysisSegmentDomain }
